<template>
  <router-link class="BotonVerMapa dIB mT20" :to="route">Ver Mapa</router-link>
</template>

<script>
export default {
  props: {
    route: {
      type: String,
      required: true,
    }
  },
  name: 'BotonVerMapa'
}
</script>

<style lang="scss" scoped>
@import "../Css/Componentes.scss";
</style>